import { IAvailableStockInfoItem } from '../types/stockOrders';
import { IShipmentData, SHIPMENT_STATUS } from '../types/orders';

export const areAllReservedProductsDelivered = (
  reservedProducts: IAvailableStockInfoItem[],
  deliveredShipments: IShipmentData[],
  sku: string
): boolean => {

  if (!reservedProducts || reservedProducts?.length === 0) {
    return false;
  }

  const deliveredShipmentsData = deliveredShipments?.filter(
    shipment => shipment?.status === SHIPMENT_STATUS.DELIVERED
  );

  const deliveredProducts = deliveredShipmentsData?.flatMap(shipment =>
    shipment?.products?.filter(product => product?.sku === sku)
  );

  return reservedProducts?.every(reservedProduct =>
    deliveredProducts?.some(
      deliveredProduct =>
        deliveredProduct?.serial &&
        reservedProduct?.serial &&
        deliveredProduct?.serial === reservedProduct?.serial &&
        deliveredProduct?.sku === sku
    )
  );
};
